/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Show_TimerInputs */



/**
* | output |
* | --- |
* | "Show session timer" |
*
* @param {Live_Caption_Show_TimerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_show_timer = /** @type {((inputs?: Live_Caption_Show_TimerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Show_TimerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher le minuteur de session")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sitzungstimer anzeigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra il timer della sessione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Показать таймер сессии")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar temporizador de sesión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示会话计时器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セッションタイマーを表示する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेशन टाइमर दिखाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mostrar cronômetro da sessão")
	return /** @type {LocalizedString} */ ("Show session timer")
});